const DEF = { SECTION_COLS: 8 };

export default {
  setCommonAttributes,
  toString: valueToString,
  isRegister: viewField => !!viewField.properties,
};

function setCommonAttributes(elementName, viewField, engineApi, { setDisabled = false } = {}) {
  if (viewField.model && !engineApi._modelsToInit[viewField.model]) {
    //@odeniel: porque: typeof engineApi._modelsToInit[viewField.model] === 'undefined'
    //@odeniel: porque: !engineApi._modelsToInit[viewField.model] (= no esta definido ya como array)
    // esta por culpa de la inicialización de datos para calculos en ecFormBuilderDirective:initRegistersForCalc
    // Ciertos tipos (como attachment o partner o...) usan setCommonAttributes con el modelo "padre" (para hacer un match despues)
    // el efecto malo, es que cuando estan en un "array" o "list", redefinen el modelo 'array' como 'objeto'
    // ej. CAB.ADJUNTO es un array de adjuntos, se define como array primero
    //     CAB.ADJUNTO.ANNEXO es el campo del fichero que actualiza tambien CAB.ADJUNTO.FORMATO y CAB.ADJUNTO.NAME
    //     cuando se crea el tipo attachment, llama setCommonAttributes con CAB.ADJUNTO y lo redefine como 'object' -> error
    // Entonces verificamos primero que no esta nada definido, la solución correcta sería de quitar ecFormBuilderDirective:initRegistersForCalc
    engineApi._modelsToInit[viewField.model] = isArray(viewField);
  }

  handleInheritProperties(viewField, engineApi); // @odeniel para que los campos herenden de padres de padres ...

  const element = new engineApi.Element(elementName).addAttributes(
    {
      'x-path': viewField.model,
      name: viewField.name,
      model: engineApi.utils.getLastItem(viewField.model),
      'ec-flex': viewField.cols || DEF.SECTION_COLS,
      'ng-show': engineApi.property.getVisible(viewField),
    },
    true
  );

  element.addAttribute(
    'fb-hidden',
    JSON.stringify({
      registerName: engineApi.registerName,
      name: viewField.name,
    }),
    true,
    "'"
  );

  if (engineApi.property.getFbFlash(viewField, viewField.parent)) {
    viewField.fbFlash = true;
    // si existe function flash para el tipo
    element.addAttribute('fb-flash', engineApi.registerFbFlash(viewField.model));
  }

  isArray(viewField) && element.addAttribute('data', engineApi.utils.getLastItems(viewField.model, 2)); // si es un array?
  viewField.cols && viewField.cols <= 6 && element.addAttribute('ec-responsive', ''); // si es poco ancho

  setDisabled && setDisabledAttribute(element, viewField);

  return element;
}

function setDisabledAttribute(element, viewField) {
  // @odeniel - El disabled no lo queremos para todos los registros,
  // por ejemplo, si lo queremos para array y list pero no para tab
  // entonces la gestión del disabled se delega a cada servicio del tipo
  // Esta función centraliza la logica de optimización
  if (viewField.disabled === 'true' || viewField.disabled === true) {
    element.addAttribute('disabled', '');
  } else if (typeof viewField.disabled === 'string') {
    element.addAttribute('ng-disabled', viewField.disabled);
  }
}

function valueToString(viewField, engineApi) {
  return value => {
    const getValue = prop => {
      try {
        return value?.[prop.model.split('.').slice(-1)[0]] || '';
      } catch (e) {
        return '';
      }
    };
    return (viewField.properties || [])
      .map(prop => {
        if ('string number select'.includes(prop.type)) {
          return engineApi.field.toString(prop)(getValue(prop));
        }
        return '';
      })
      .filter(item => item !== '')
      .join(' ');
  };
}

function handleInheritProperties(viewField, engineApi) {
  // para que los campos herenden el disabled de los padres (se contruira: ((expDisabled1) || expDisabled2) || ...
  viewField.disabled = engineApi.property.getDisabled(viewField, engineApi.options.isReadOnly);
}

/**
 * Devuelve true si el viewField es un array
 * @param {object} viewField
 * @return {boolean}
 */
function isArray(viewField) {
  // odeniel => viewField.max esta DEPRECATED. Lo dejamos por retrocompatibilidad
  const max = viewField.max || (viewField.metadata || {}).max;
  if (typeof max === 'number' && max > 1) {
    return true;
  }
  return false;
}
